module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/version.js
// module id = 13
// module chunks = 0